<template>
  <div>
    <div class="list">
      <div class="list__wrapper">
        <table class="list__table">
          <thead>
            <tr class="list__table-heading-tr">
              <th v-for="{ label, property } in columns" :key="{ label }">
                <span>
                  {{ $t(label) }}
                  <div class="list__sort-buttons">
                    <button
                      class="list__sort-button-up"
                      :class="{
                        active:
                          sortProperty.property === flatProperties[property] &&
                          !sortProperty.reverse,
                      }"
                      @click="handleSortBtn(property, false)"
                    />
                    <button
                      class="list__sort-button-down"
                      :class="{
                        active:
                          sortProperty.property === flatProperties[property] &&
                          sortProperty.reverse,
                      }"
                      @click="handleSortBtn(property, true)"
                    />
                  </div>
                </span>
              </th>
              <th class="hidden-lg"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="flat in pages[activePage]"
              class="list__table-row"
              :key="flat[flatProperties['id']]"
              @click="handleRowClick($event, flat)"
            >
              <td>{{ flat[flatProperties['id']] }}</td>
              <td>
                {{ Number(flat[flatProperties['area']]).toFixed(2) }} m<sup
                  >2</sup
                >
              </td>
              <td>{{ flat[flatProperties['floor']] }}</td>
              <td>{{ flat[flatProperties['rooms']] }}</td>
              <td v-if="Number(flat[flatProperties.balcony])">
                {{ Number(flat[flatProperties['balcony']]).toFixed(2) }}
                m<sup>2</sup>
              </td>
              <td v-else>-</td>
              <td :class="getStatusClass(flat)">
                {{ getStatus(flat[flatProperties['status']]) }}
              </td>
              <td class="hidden-lg">
                <button @click="handleFavClick(flat)" class="list__favourite">
                  <img
                    v-if="isFavourite"
                    src="@/assets/close.svg"
                    alt="delete"
                    title="Usuń z ulubionych"
                  />
                  <img
                    v-else-if="checkIsFlatFavourite(flat)"
                    src="@/assets/full-heart.svg"
                    alt="heart"
                    title="Usuń do ulubionych"
                  />
                  <img
                    v-else
                    src="@/assets/heart-list.svg"
                    alt="heart"
                    title="Dodaj do ulubionych"
                  />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <Pagination
      v-if="pages.length > 1"
      :activePage="activePage"
      :setActivePage="page => (this.activePage = page)"
      :totalPages="pages.length"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import Pagination from '../components/list-pagination';
import { sortBy } from '../utils';

const getFlatPages = flats => {
  return flats
    .map((_, i, all) => all.slice(i * 10, (i + 1) * 10))
    .filter(x => x.length);
};

export default {
  name: 'list',
  components: {
    Pagination,
  },
  data() {
    return {
      isDesktop: true,
      sortProperty: {
        property: null,
        reverse: false,
      },
      activePage: 0,
      columns: [
        { label: 'apartment', property: 'id' },
        { label: 'singleFlat.area', property: 'area' },
        { label: 'singleFlat.floor', property: 'floor' },
        { label: 'singleFlat.rooms', property: 'rooms' },
        { label: 'filters.balcony', property: 'balcony' },
        { label: 'singleFlat.status', property: 'status' },
      ],
    };
  },
  props: {
    flats: { type: Array, required: true },
  },
  computed: {
    ...mapGetters({
      getStatus: 'GET_STATUS_NAME',
      investmentURL: 'GET_INVESTMENT_URL',
    }),
    ...mapState({
      flatProperties: state => state.browser.flatProperties,
      sorting: state => state.browser.sorting,
    }),
    isFavourite() {
      return this.$route.name == 'favourites';
    },
    pages() {
      return getFlatPages(this.sortedFlats || this.flats);
    },
    sortedFlats() {
      const { property, reverse } = this.sortProperty;
      let sortedFlats = this.flats;

      if (property) {
        sortedFlats = sortedFlats.sort(sortBy(property, reverse));
      }

      return sortedFlats;
    },
  },
  created() {
    if (window.innerWidth < 992) {
      this.isDesktop = false;
    }
  },
  watch: {
    sortedFlats() {
      this.activePage = 0;
    },
  },
  methods: {
    ...mapMutations({
      addToFavourites: 'ADD_TO_FAVOURITES',
      deleteFromFavourites: 'DELETE_FROM_FAVOURITES',
    }),
    getStatusClass(flat) {
      return this.$store.getters.GET_STATUS_CLASS(
        flat[this.flatProperties['status']]
      );
    },
    getFlatURL(flat) {
      if (flat.investment)
        return `/${flat.investment.url}/flat/${
          flat[this.flatProperties['id']]
        }`;
      return `/${this.investmentURL}/flat/${flat[this.flatProperties['id']]}`;
    },
    checkIsFlatFavourite(flat) {
      let favs = this.$store.getters.GET_FAVOURITES.map(
        fav => fav[this.flatProperties['id']]
      );

      return favs.includes(flat[this.flatProperties['id']]);
    },
    handleRowClick(e, flat) {
      const clickedButton =
        e.target.parentNode.tagName === 'BUTTON' ||
        e.target.tagName === 'BUTTON';
      if (this.isDesktop && !clickedButton) {
        this.$nextTick(() => {
          window.top.postMessage(
            `GO_TO_FLAT/${flat[this.flatProperties['id']]}`,
            '*'
          );
        });
      } else if (!clickedButton) {
        this.$emit('toggleForm', flat[this.flatProperties['id']]);
      }
    },
    handleFavClick(flat) {
      window.top.postMessage(
        `TOGGLE_FAVOURITE/${flat[this.flatProperties['id']]}`,
        '*'
      );
      if (!this.checkIsFlatFavourite(flat)) {
        window.top.postMessage(
          `ADD_FAVOURITE/${flat[this.flatProperties['id']]}`,
          '*'
        );
      } else {
        window.top.postMessage(
          `REMOVE_FAVOURITE/${flat[this.flatProperties['id']]}`,
          '*'
        );
      }
    },
    handleSortBtn(property, reverse) {
      this.sortProperty = {
        property: this.flatProperties[property],
        reverse: reverse,
      };
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  position: relative;
  width: 100%;
  height: 100%;
  margin-bottom: 30px;
  padding-right: 150px;
  @media (max-width: 439px) {
    margin-left: -20px;
    width: calc(100% + 40px);
  }
  .hidden-lg {
    @media (max-width: 991px) {
      display: none;
    }
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 150px;
    width: 25px;
    height: 100%;
    background: linear-gradient(88deg, #0000000d, #00000000);
  }
  @media (min-width: 992px) {
    padding-right: 0;
    &:after {
      content: none;
    }
  }
  &__wrapper {
    width: 100%;
    margin-left: 150px;
    overflow-x: auto;
    overflow-y: visible;
    @media (min-width: 992px) {
      margin-left: 0;
      overflow-x: visible;
    }
  }
}

.list__table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 10px;
  border: none;
  td,
  th {
    position: relative;
    padding: 15px 20px;
    white-space: nowrap;
    border-bottom: 1px solid #ebebeb;
    &:first-of-type {
      padding-left: 20px;
      position: absolute;
      left: 0;
      width: 150px;
      @media (min-width: 992px) {
        position: static;
        width: auto;
        left: auto;
      }
    }
    @media (min-width: 992px) {
      padding: 20px 25px;
    }
  }
  td {
    &:first-of-type {
      padding-bottom: 17px;
      @media (min-width: 992px) {
        padding-bottom: 20px;
      }
    }
  }
  th {
    text-align: left;
    background-color: #f7f7f7;
    color: #111111;
  }
  td {
    &.available {
      color: $available;
    }

    &.reserved {
      color: $reserved;
    }

    &.sold {
      color: $sold;
    }
  }
}

.list__table-heading-tr {
  th {
    padding: 20px 25px;
    line-height: 45px;
    font-weight: 400;
    &:last-child {
      width: 100px;
    }
    span {
      position: relative;
    }
  }
}

.list__table-row {
  transition: 0.2s;
  color: #3e3e3e;
  box-shadow: none;
  cursor: pointer;
  @media (hover: hover) {
    &:hover {
      background-color: #f5f5f5;
      color: #000;
      box-shadow: 0px 6px 12px #00000012;
    }
  }
}

.list__promo-label {
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  padding: 5px 8px;
  background: $primaryColor;
  color: #fff;
  max-width: max-content;
  font-weight: 700;
  font-size: 12px;
  border-radius: 4px;
  min-width: 80px;
}

.list__favourite {
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;
  margin: 0;
  background: transparent;
  border: none;

  width: 36px;
  transition: 0.3s;

  cursor: pointer;

  img {
    max-height: 50%;
    max-width: 50%;
  }

  &:focus {
    outline: none;
    border: 2px solid $primaryColor;
  }
}

.list__sort-buttons {
  position: absolute;
  right: -20px;
  top: 2px;
  display: flex;
  flex-direction: column;
}

.list__sort-button-up {
  width: 0px;
  height: 0px;
  padding: 0;
  background: transparent;
  cursor: pointer;
  border-style: solid;
  border-width: 0 6px 6px;
  border-color: transparent transparent $darkGray;
  &.active {
    border-color: transparent transparent $primaryColor;
  }
}

.list__sort-button-down {
  @extend .list__sort-button-up;
  border-width: 6px 6px 0;
  border-color: $darkGray transparent transparent;
  margin-top: 4px;
  &.active {
    border-color: $primaryColor transparent transparent;
  }
}
</style>
